import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Offcanvas } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import * as yup from "yup";
import FormInput from "../forms/FormInput";
import PhoneInput from "../forms/PhoneInput";
import RichEditor from "../../pages/settings/components/RichEditor";
import { RichEditorType } from "../../pages/settings/components/RichEditorType";
import React, { useEffect, useState } from "react";
import {
  useGetUserProfileQuery,
  useUpdateSettingsMutation,
} from "../../features/users/usersApi";

const schema = yup
  .object({
    first_name: yup.string().required(),
    last_name: yup.string().required(),
    mobile_number: yup.string().required(),
    country_code: yup.string().optional(),
    email: yup.string().email().required(),
    date_of_birth: yup.string().required(),
    signature: yup.string().required(),
    service_description: yup.string().required(),
  })
  .required();

interface CompleteProfileProps {
  show: boolean;
  onHide: () => void;
}

const CompleteProfile: React.FC<CompleteProfileProps> = ({ show, onHide }) => {
  const { data: userProfile } = useGetUserProfileQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  const [updateSettions] = useUpdateSettingsMutation();
  const [mobileNumber, setMobileNumber] = useState("");

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      first_name: "",
      last_name: "",
      mobile_number: "",
      email: "",
      date_of_birth: "",
      signature: "",
      service_description: "",
    },
  });

  useEffect(() => {
    if (userProfile?.data) {
      methods.reset({
        first_name: userProfile.data.first_name,
        last_name: userProfile.data.last_name,
        mobile_number: userProfile.data.mobile_number,
        email: userProfile.data.email,
        date_of_birth: userProfile.data.date_of_birth,
        signature: userProfile.data.signature,
        service_description: userProfile.data.service_description,
      });
      setMobileNumber(userProfile.data.mobile_number);
    }
  }, [userProfile]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = methods;

  const onSubmit = async (data: any) => {
    updateSettions({
      first_name: data.first_name,
      last_name: data.last_name,
      mobile_number: data.mobile_number,
      signature: data.signature,
      service_description: data.service_description,
    })
      .unwrap()
      .then(() => {
        onHide();
      })
      .catch((error) => {
        console.error("Error updating profile:", error);
      });
  };

  const handleMobileChange = (value: string, countryCode?: string) => {
    setMobileNumber(value);
    setValue("mobile_number", value, {
      shouldDirty: true,
      shouldValidate: true,
    });
    if (countryCode) {
      setValue("country_code", countryCode, {
        shouldDirty: true,
      });
    }
  };

  return (
    <Offcanvas show={show} onHide={onHide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Complete Your Profile</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <p>Please complete your profile to get started.</p>
        {/* Add your form or content here */}
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <FormProvider {...methods}>
            <div>
              <FormInput
                className="mb-2"
                label="First name"
                name="first_name"
                register={register}
                errors={errors}
              />
              <FormInput
                className="mb-2"
                label="Last name"
                name="last_name"
                register={register}
                errors={errors}
              />
              <PhoneInput
                className="mb-2"
                label="Mobile Number"
                name="mobile_number"
                value={mobileNumber}
                onChange={handleMobileChange}
                errors={errors}
              />
              <FormInput
                className="mb-2"
                label="Email"
                disabled
                name="email"
                register={register}
              />
              {/* <FormInput
                type="date"
                label="Date of birth"
                name="date_of_birth"
                className="mb-2"
                register={register}
                errors={errors}
              /> */}

              <FormInput
                type="textarea"
                rows="5"
                label="About your service"
                name="service_description"
                register={register}
                errors={errors}
                className="mb-2"
              />

              <RichEditor type={RichEditorType.SIGNATURE} name="signature" />

              <div className="d-flex justify-content-end mt-3">
                <Button type="submit" variant="primary">
                  Save Profile
                </Button>
              </div>
            </div>
          </FormProvider>
        </form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default CompleteProfile;
